import { Dialog, Grid, Typography, Button, TextField, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";

const StandardPlanEditPopup = ({
    open,
    onClose,
    onConfirm,
    title = "Confirm Action",
    message,
    confirmLabel = "Save",
    cancelLabel = "Cancel",
    updatingStandardPlanAlias
}) => {
    const [alias, setAlias] = useState("");

    useEffect(()=>{
        if(message){
            setAlias(message?.plan_name)
        }
    },[message])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ style: { overflow: "hidden" } }}
        >
            <Grid container spacing={2} style={{ padding: "1em" }}>
                {title && (
                    <Grid item xs={12}>
                        <Typography
                            variant="h5"
                            component="div"
                            align="center"
                            style={{ fontWeight: "bold", color: "#424141" }}
                        >
                            {title}
                        </Typography>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={alias}
                        onChange={(e) => setAlias(e.target.value)}
                        sx={{ mt: 1 }}
                    />
                </Grid>

                <Grid
                    item
                    xs={12}
                    className="starlink--base--flex starlink--base--mtb_07x starlink--base--flex--justify--end"
                >
                    <Button
                        variant="outlined"
                        className="starlink--button--cancel"
                        onClick={onClose}
                    >
                        {cancelLabel}
                    </Button>
                    <Button
                        variant="contained"
                        className="starlink--button_contained--primary"
                       onClick={() => {onConfirm(alias, message)}}
                    >
                     {updatingStandardPlanAlias ?  <CircularProgress size={"small"} sx={{color:"white"}} /> : confirmLabel }
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    );
};

export default StandardPlanEditPopup;
